export const QANTAS_TERMS_AND_CONDITIONS_URL =
  'https://www.qantas.com/au/en/business-rewards/terms-and-conditions.html#program'

export const QANTAS_PRIVACY_POLICY_URL =
  'https://www.qantas.com/au/en/support/privacy-and-security.html'

export const MARMALADE_PRIVACY_POLICY_URL =
  'https://www.marmalade.com.au/privacy-policy'
